import { inject, observer } from "mobx-react";

const Logout = ( props ) => {
	
	props.Auth.logout()
	
	return window.location = "/login";
	
}

export default inject( 'Auth' )( observer( Logout ) )
